// tslint:disable:no-import-side-effect
import 'promise/polyfill';

import { WebApiSettings, WebAPI } from './web-api';

export function esalesAPI(settings: WebApiSettings): WebAPI {
  return new WebAPI(settings);
}
